import React from 'react';
import EditGameState from './editGameState/EditGameState';
import ControlPanel from './components/ControlPanel/ControlPanel';
import Forms from './components/Forms/Forms';
import { ModalWindows } from './components/ModalWindows/ModalWindows';

const EditGamePage: React.FC = () => {
	return (
		<EditGameState>
			<ControlPanel />
			<Forms />
			<ModalWindows />
		</EditGameState>
	);
};

export default EditGamePage;
